// =============================================================================
// STORAGE KEYS - Централізовані ключі для localStorage та sessionStorage
// =============================================================================

/**
 * Keys for localStorage - persistent across sessions
 */
export const STORAGE_KEYS = {
  /** Full game progress state */
  GAME_PROGRESS: 'war-game-progress',
  /** Donation campaign data (if playing campaign) */
  DONATION_CAMPAIGN: 'war-game-donation-campaign',
} as const;

/**
 * Keys for sessionStorage - cleared when tab closes
 */
export const SESSION_KEYS = {
  /** Whether action strip has been shown this session */
  ACTION_STRIP_SHOWN: 'war-game-action-strip-shown',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
export type SessionKey = (typeof SESSION_KEYS)[keyof typeof SESSION_KEYS];
